<div [ngClass]="overRideClass">
  <p-rating
    [(ngModel)]="value"
    [stars]="5"
    [readonly]="readOnly"
    [cancel]="false"
    (onRate)="handleRate($event)"
  ></p-rating>
</div>
